import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ContextMenu, Dropdown, HooksService, Item, MenuButton } from 'basic-components';
import { Menu as MenuIcon } from 'basic-components/icons';
import Query from 'dashboard-services/api/Query';

import { creatorCurvesActions } from 'actions/curves';
import getApiConfig from 'api/ApiConfig';
import { basicCurvesQueries } from 'queries/curves';

import DefaultColumnsListModal from 'primary/DefaultColumnsListModal';

import './Columns.scss';

const emptyArray = []
const Columns = () => {
  const dispatch = useDispatch(),
        selectedCurves = useSelector(state => state.curvesState.creatorState.selectedCurves) || emptyArray,
        selectedColumns = useSelector(state => state.curvesState.creatorState.selectedColumns) || undefined,
        source = useSelector(state => state.globalState.localSource),
        calls = useRef([]),
        [isDefaultColumnsListOpen, setIsDefaultColumnsListOpen] = useState(false),
        openDefaultColumnsList = useCallback(() => setIsDefaultColumnsListOpen(true), []),
        closeDefaultColumnsList = useCallback(() => setIsDefaultColumnsListOpen(false), []),
        onChange = useCallback((value, { name }) => dispatch(creatorCurvesActions.onChange(value, name)), [dispatch]),
        getQueryBuilder = useCallback(() => 
          new Query.Builder(dispatch(getApiConfig()))
            .withFetching(false)
            .withHeader("Target", source, true)
        , [dispatch, source]),
        { data: columns = emptyArray } = basicCurvesQueries.useGetColumns({ getQueryBuilder, selectedCurves, source }),
        prevColumns = HooksService.usePrevious(columns),
        prevSelectedColumns = HooksService.usePrevious(selectedColumns),
        columnsRef = useRef(),
        onChangeColumns = useCallback(value => dispatch(creatorCurvesActions.onChange(value, "selectedColumns")), [dispatch])

  useEffect(() => {
    if((!prevColumns || prevColumns?.length === 0) && columns[0] && (!selectedColumns || selectedColumns?.length === 0) && (!prevSelectedColumns || prevSelectedColumns?.length === 0)) {
      columnsRef.current?.dropdown.current?.setValue(columns[0])
    }
  }, [columns, onChange, prevColumns, prevSelectedColumns, selectedColumns])

  useEffect(() => () => {
    calls.current?.forEach(c => c?.cancel?.())
  }, [])

  return (
    <div className="ng-office-app__authed__content__basket__body__data__columns">
      <div className="ng-office-app__authed__content__basket__body__data__columns__header">
        <span 
            className="ng-office-app__authed__content__basket__body__data__columns__header__label"
            id="column"
        >
          Column
        </span>
        <div className="ng-office-app__authed__content__basket__body__data__columns__header__right">
          <ContextMenu
              className="ng-office-app__authed__content__basket__body__data__columns__header__right__context-menu"
              itemsSize="unset"
              menuButton={(
                <MenuButton key="MenuButton">
                  <div className="ng-office-app__authed__content__basket__body__data__columns__header__right__context-menu__icon">
                    <MenuIcon
                        color="blue-bright"
                        height={16}
                        width={16}
                    />
                  </div>
                </MenuButton>
              )}
              
          >
            <Item onClick={openDefaultColumnsList}>
              Default columns list
            </Item>
          </ContextMenu>
        </div>
      </div>
      <div className="ng-office-app__authed__content__basket__body__data__columns__dropdown">
        <Dropdown
            creatable
            defaultValue={selectedColumns}
            disabled={selectedCurves.length === 0}
            fixed
            labelId="column"
            menuPlacement="bottom"
            menuPortalTarget={document.querySelector('.ng-office-app')}
            name="selectedColumns"
            noError
            onChange={onChange}
            options={columns}
            placeholder="Columns"
            ref={columnsRef}
            variant="border"
        />
      </div>
      {isDefaultColumnsListOpen ? (
        <DefaultColumnsListModal
            close={closeDefaultColumnsList}
            onChangeColumns={onChangeColumns}
        />
      ) : undefined}
    </div>
  )
}

export default Columns;
